import { parse } from 'date-fns';
import { useCallback } from 'react';
import { TIME_FORMAT } from './time-format';

export const useParseTime = () => useCallback((value: string) => parse(value, TIME_FORMAT, new Date()), []);
